/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Docs_No_Documents_FoundInputs */

const en_public_docs_no_documents_found = /** @type {(inputs: Public_Docs_No_Documents_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No documents found.`)
};

const es_public_docs_no_documents_found = /** @type {(inputs: Public_Docs_No_Documents_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron documentos.`)
};

/**
* | output |
* | --- |
* | "No documents found." |
*
* @param {Public_Docs_No_Documents_FoundInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const public_docs_no_documents_found = /** @type {((inputs?: Public_Docs_No_Documents_FoundInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Docs_No_Documents_FoundInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_public_docs_no_documents_found(inputs)
	return en_public_docs_no_documents_found(inputs)
});